import ConfigList from './ConfigList.vue';

export default ConfigList;
